/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPagingResponseOfTourOperatorAllotmentFromDiscriminatorValue, createValidationProblemDetailsFromDiscriminatorValue, serializeAgGridClientQuery, serializePagingResponseOfTourOperatorAllotment, type AgGridClientQuery, type PagingResponseOfTourOperatorAllotment, type ValidationProblemDetails } from '../../models/index.js';
// @ts-ignore
import { GetForTourOperatorItemRequestBuilderRequestsMetadata, type GetForTourOperatorItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Allotment/GetForTourOperator
 */
export interface GetForTourOperatorRequestBuilder extends BaseRequestBuilder<GetForTourOperatorRequestBuilder> {
    /**
     * Gets an item from the ApiSdk.Allotment.GetForTourOperator.item collection
     * @param id Unique identifier of the item
     * @returns {GetForTourOperatorItemRequestBuilder}
     */
     byId(id: number) : GetForTourOperatorItemRequestBuilder;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagingResponseOfTourOperatorAllotment>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     post(body: AgGridClientQuery, requestConfiguration?: RequestConfiguration<GetForTourOperatorRequestBuilderPostQueryParameters> | undefined) : Promise<PagingResponseOfTourOperatorAllotment | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: AgGridClientQuery, requestConfiguration?: RequestConfiguration<GetForTourOperatorRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
export interface GetForTourOperatorRequestBuilderPostQueryParameters {
    showUpToDate?: boolean;
}
/**
 * Uri template for the request builder.
 */
export const GetForTourOperatorRequestBuilderUriTemplate = "{+baseurl}/Allotment/GetForTourOperator?showUpToDate={showUpToDate}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const GetForTourOperatorRequestBuilderNavigationMetadata: Record<Exclude<keyof GetForTourOperatorRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        requestsMetadata: GetForTourOperatorItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["id"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const GetForTourOperatorRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: GetForTourOperatorRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagingResponseOfTourOperatorAllotmentFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAgGridClientQuery,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
